export const User = () => {
  const localData = JSON.parse(localStorage.getItem("local_data"));
  const user = localData?.user;
  console.log("user", user);
  return user;
};
export const newUser = User();
